import ModalSurface from "./ModalSurface";

export default function Sheet({ side = "bottom", surfaceClassName = "", ...props }) {
  return (
    <ModalSurface
      {...props}
      kind="sheet"
      surfaceClassName={`lz-v2-sheet--${side} ${surfaceClassName}`.trim()}
    />
  );
}
